.region {
	position: fixed;
	z-index: 30;
	bottom: max(24px, calc(env(safe-area-inset-bottom) + 12px));
	left: 50%;
	width: min(360px, calc(100vw - 32px));
	transform: translateX(-50%);
	pointer-events: none;
}

.toast {
	display: grid;
	grid-template-columns: 76px minmax(0, 1fr);
	min-height: 84px;
	border: 2px solid var(--ink);
	background: var(--ink);
	box-shadow: 4px 4px 0 var(--yellow);
	animation: achievement-arrive var(--toast-duration) both;
}

.badge {
	position: relative;
	display: grid;
	place-items: center;
	border-right: 2px solid var(--ink);
	color: var(--ink);
	background: #fff;
}

.badge svg {
	width: 48px;
	height: 48px;
}

.copy {
	position: relative;
	display: flex;
	min-width: 0;
	padding: 16px 28px 16px 16px;
	flex-direction: column;
	justify-content: center;
	gap: 5px;
}

.composition {
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	opacity: 0.65;
}

.copy span,
.copy strong {
	position: relative;
}

.copy span {
	color: var(--yellow);
	font-size: 13px;
	font-weight: 700;
	line-height: 1.3;
}

.copy strong {
	color: #fff;
	font-size: 16px;
	line-height: 1.35;
	overflow-wrap: anywhere;
}

.particles {
	position: absolute;
	z-index: 1;
	inset: 50%;
}

.particles > i {
	position: absolute;
	animation: achievement-drift var(--duration) calc(220ms + var(--delay)) linear both;
}

.particles b {
	display: block;
	width: 7px;
	height: 7px;
	border: 1px solid var(--ink);
	background: var(--yellow);
	opacity: 0;
	animation: achievement-debris var(--duration) calc(220ms + var(--delay)) both;
}

.particles i:nth-child(3n) b {
	background: var(--mint);
}

.particles i:nth-child(3n + 2) b {
	width: 5px;
	height: 5px;
	background: #fff;
}

@keyframes achievement-arrive {
	0% {
		opacity: 0;
		transform: translateY(calc(100% + 40px));
	}
	7% {
		opacity: 1;
		transform: translateY(-5px);
	}
	10%,
	90% {
		opacity: 1;
		transform: translateY(0);
	}
	100% {
		opacity: 0;
		transform: translateY(calc(100% + 40px));
	}
}

@keyframes achievement-drift {
	from {
		transform: translateX(0);
	}
	to {
		transform: translateX(var(--x));
	}
}

@keyframes achievement-debris {
	0% {
		opacity: 0;
		transform: translateY(0) rotate(0deg);
		animation-timing-function: ease-out;
	}
	5% {
		opacity: 1;
	}
	38% {
		transform: translateY(var(--y)) rotate(30deg);
		animation-timing-function: ease-in;
	}
	85% {
		opacity: 1;
	}
	100% {
		opacity: 0;
		transform: translateY(110px) rotate(100deg);
	}
}

@media (max-width: 620px) {
	.toast {
		grid-template-columns: 64px minmax(0, 1fr);
	}
	.copy {
		padding: 16px 24px 16px 14px;
	}
	.copy strong {
		font-size: 14px;
	}
	.copy span {
		font-size: 12px;
	}
}

@media (prefers-reduced-motion: reduce) {
	.toast {
		animation: none;
	}
	.particles {
		display: none;
	}
}
